<template>
  <div>
    <div class="ts-relative ts-mt-1">
      <div
        class="ts-absolute ts-inset-y-0 ts-left-0 ts-flex ts-items-center ts-pl-3 ts-pointer-events-none"
      >
        <svg
          class="ts-w-5 ts-h-5 ts-text-gray-500 dark:ts-text-gray-400"
          fill="currentColor"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
            clip-rule="evenodd"
          ></path>
        </svg>
      </div>
      <input
        v-model="search"
        type="text"
        id="table-search"
        class="ts-border ts-text-gray-900 ts-text-sm ts-rounded  ts-outline-none ts-block ts-w-full ts-pl-10 ts-p-2"
        :placeholder="$t('visitation.typeToSearchDistrict')"
      />
    </div>
    <div
      class="ts-h-40 ts-border ts-border-gray-100 700 ts-p-3 ts-overflow-y-scroll"
    >
      <table class="ts-w-full">
        <tr>
          <td class="ts-w-3 ts-pr-4 ts-p-1 ts-sticky ts-top-0 ts-z-10 ts-bg-white" style="width: 10px">
            <input 
              type="checkbox" 
              class="ts-cursor-pointer" 
              id="d_check_all"
              :checked="isCheckAll"
              @change="onCheckAll"
            />
          </td>
          <td class="ts-sticky ts-top-0 ts-z-10 ts-bg-white">
            <label for="d_check_all" class="ts-mb-0 ts-font-normal ts-cursor-pointer">{{ $t('visitation.checkAll') }}</label>
          </td>
        </tr>
        <tr v-for="(d, index) in itemList" :key="index" class="ts-border-b">
          <td class="ts-w-3 ts-pr-4 ts-p-1">
            <input
              type="checkbox"
              v-model="checkedItem"
              :value="d.district_code"
              @change="onChange"
              :id="'d_check_' + index"
              class="ts-cursor-pointer"
            />
          </td>
          <td>
            <label
              :for="'d_check_' + index"
              class="ts-mb-0 ts-font-normal ts-cursor-pointer"
            >
              {{ d.district_code + '-' + d.name_kh }}
              <span class="ts-text-blue-700">{{ d.name_en }}</span>
            </label>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'districtSearch',
  props: ['value'],
  data() {
    return {
      search: '',
      items: [],
      checkedItem: [],
      model: {}
    }
  },
  created() {
    this.model = this.value
  },
  computed: {
    itemList() {
      return this.items.filter(
        v =>
          v.district_code.indexOf(this.search.trim()) >= 0 ||
          v.name_kh.indexOf(this.search.trim()) >= 0 ||
          v.name_en.toLowerCase().indexOf(this.search.toLowerCase().trim()) >= 0
      )
    },
    isCheckAll(){
      if(!this.checkedItem.length) return false
      return this.checkedItem.length == this.items.length;
    }
  },
  methods: {
    ...mapActions('customer/visitation', ['getFormViewModel']),
    fetchDistrict({ provinceCode }) {
      this.$emit('loading', true)
      this.getFormViewModel({
        fnName: 'district',
        province_code: provinceCode,
        sale_id: this.model.sale_id
      })
        .then(response => {
          this.items = response.data['district']
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.$emit('loading', false)
        })
    },
    onChange(e) {
      if (!e.target.checked) {
        var district = this.model.customer_list.filter(
          c => c.district_code == e.target.value
        )
        district.forEach(v => {
          this.model.customer_list.splice(
            this.model.customer_list.indexOf(this.findById(v)),
            1
          )
        })
      }
      this.$emit('itemCheck', this.checkedItem)
    },
    findById(v) {
      return this.model.customer_list.find(c => c.district_code == v.district_code)
    },
    onCheckAll(e){
      if(!e.target.checked){
        this.checkedItem = []
        this.model.customer_list = []
        this.$emit('itemCheck', [])
        return
      }
      this.checkedItem = this.itemList.map(el => el.district_code)

      this.$emit('itemCheck', this.checkedItem)
    }
  }
}
</script>
